import apiClient from './apiClient';

const settingsService = {
  getOrganizationSettings: async (organizationId) => {
    const response = await apiClient.get(`/organizations/${organizationId}/settings`);
    return response.data;
  },

  updateOrganizationSettings: async (organizationId, payload) => {
    const response = await apiClient.put(`/organizations/${organizationId}/settings`, payload);
    return response.data;
  },

  uploadOrganizationLogo: async (organizationId, file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await apiClient.post(`/organizations/${organizationId}/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  getFiscalYears: async (organizationId) => {
    const response = await apiClient.get(`/fiscal-years?organizationId=${organizationId}`);
    return response.data;
  },

  getPayrollTemplates: async () => {
    const response = await apiClient.get('/payslip-templates');
    return response.data;
  }
};

export default settingsService;
